import { defineMessages } from 'react-intl';

export const orderAgainRailHeadingMessages = defineMessages({
  heading: {
    defaultMessage: 'Order again',
    description: 'Orders rail | Heading',
  },
});
